function initializeQuantityHandlers() {
  const quantityWrappers = document.querySelectorAll('[data-quantity-wrapper]');
  
  quantityWrappers.forEach(wrapper => {
    new window.Quantity(wrapper);
  });
}
function initializeRemoveHandlers() {
  const removeItems = document.querySelectorAll('.sidecart .cart-item--remove-link');
  removeItems.forEach(item => {
    item.addEventListener('click', (event) => {
      event.currentTarget.closest('li.cart-item').classList.add('removed');
      setTimeout(() => {console.log('hello');}, 1000);
    });
  });
}

function initializeSidebarHandlers() {
  let sidebarParent = document.querySelector("#shopify-section-sidecart");
  let closeSidebar = document.querySelectorAll('.sidecart-close');

  closeSidebar.forEach(item => {
    item.addEventListener('click', (event) => {
      sidebarParent.classList.remove('live');
    });
  });
}

function initializeAllCartHandlers() {
  initializeQuantityHandlers();
  initializeRemoveHandlers();
  initializeSidebarHandlers();
}


document.addEventListener('DOMContentLoaded', initializeAllCartHandlers);
window.initializeAllCartHandlers = initializeAllCartHandlers;